import axios from "axios";

const baseURL = process.env.REACT_APP_API_URL || "/api";
const TOKEN_KEY = "instamatch_token";

export const getToken = () => {
  try {
    return localStorage.getItem(TOKEN_KEY) || "";
  } catch {
    return "";
  }
};

export const setToken = (t) => {
  try {
    if (t) localStorage.setItem(TOKEN_KEY, t);
    else localStorage.removeItem(TOKEN_KEY);
  } catch {
    /* private mode: the session just won't persist */
  }
};

export const api = axios.create({ baseURL });

api.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

// An expired/invalid token sends the user back to the login screen.
api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401 && !err.config?.url?.startsWith("/auth/")) {
      setToken("");
      window.location.reload();
    }
    return Promise.reject(err);
  }
);

// <img> can't send headers, so the token rides along as ?t=.
export const imageUrl = (leadId) => {
  const t = getToken();
  return `${baseURL}/images/${leadId}${t ? `?t=${encodeURIComponent(t)}` : ""}`;
};

export const downloadFile = async (path, filename) => {
  const { data } = await api.get(path, { responseType: "blob" });
  const url = URL.createObjectURL(data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
};

export const fmtDuration = (seconds) => {
  const s = Math.round(seconds || 0);
  if (s < 60) return `${s}s`;
  const m = Math.floor(s / 60);
  if (m < 60) return `${m}m ${s % 60}s`;
  const h = Math.floor(m / 60);
  return `${h}h ${m % 60}m`;
};

export const fmtCount = (n) => {
  if (n == null) return "?";
  if (n >= 1_000_000) return `${(n / 1_000_000).toFixed(n >= 10_000_000 ? 0 : 1)}M`;
  if (n >= 10_000) return `${Math.round(n / 1000)}k`;
  if (n >= 1000) return `${(n / 1000).toFixed(1)}k`;
  return String(n);
};

export const parseSpec = (s) => {
  try {
    return s ? JSON.parse(s) : null;
  } catch {
    return null;
  }
};

export const fmtUsd = (x) => {
  const v = Number(x) || 0;
  if (v === 0) return "$0";
  return v >= 1 ? `$${v.toFixed(2)}` : `$${v.toFixed(3)}`;
};
